import React, { useState, useEffect, memo } from 'react';
import Boutton from "./Button.jsx";
import useWeather from "../hooks/useWeather";
import pub from "../assets/conference/pub.png";
import pub2 from "../assets/conference/pub-marathon.png";
import factorio from "../assets/conference/factorio.png";


const SynapseNews = memo(({ title, articles, onClose, backChoice, guerres, playerCountry, isSlide = false, focusClimate = false }) => {
    const [headerOpacity, setHeaderOpacity] = useState(0.95);
    const [climateFocusActive, setClimateFocusActive] = useState(false);
    const { temperature: currentTemp, description, min, max, lastUpdate } = useWeather();

    // Animation de focus sur Climat Global (via prop externe)
    useEffect(() => {
        if (focusClimate && isSlide) {
            setClimateFocusActive(true);
        }
    }, [focusClimate, isSlide]);

    useEffect(() => {
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            setHeaderOpacity(scrolled > 100 ? 0.98 : 0.95);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (isSlide) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isSlide, onClose]);

    // Suppression de l'ancien rafraîchissement aléatoire de la température

    const handleAIBadgeClick = (e) => {
        e.target.style.transform = 'scale(1.05)';
        setTimeout(() => {
            e.target.style.transform = 'scale(1)';
        }, 150);
    };

    const sectionStyles = {
        background: 'rgba(30, 41, 59, 0.4)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(59, 130, 246, 0.1)',
        borderRadius: '16px',
        padding: '2rem',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
    };

    const highlightCountry = (text) => {
        if (!playerCountry || !text) return text;
        const escaped = playerCountry.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escaped})`, 'gi');
        return text.split(regex).map((part, i) =>
            part.toLowerCase() === playerCountry.toLowerCase()
                ? <span key={i} className="font-bold text-yellow-300">{part}</span>
                : part
        );
    };

    return (
        <div className={isSlide ? "w-full h-full overflow-hidden" : "popup-overlay"}>
            {/* Overlay + Focus Climat (au même niveau pour z-index) */}
            {climateFocusActive && (
                <>
                    <div
                        className="fixed inset-0 bg-black/80 z-[100] transition-opacity duration-500 cursor-pointer"
                        style={{ backdropFilter: 'blur(4px)' }}
                        onClick={() => setClimateFocusActive(false)}
                    />
                    {/* Élément Climat Global dupliqué en position fixe */}
                    <div
                        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[200] w-[500px] shadow-2xl shadow-blue-500/50 ring-4 ring-blue-400/60 animate-fade-in"
                        style={{
                            background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(30, 41, 59, 0.98))',
                            backdropFilter: 'blur(15px)',
                            border: '2px solid rgba(59, 130, 246, 0.8)',
                            borderRadius: '16px',
                            padding: '2rem',
                        }}
                    >
                        {/* Effet de glow */}
                        <div className="absolute -inset-4 rounded-3xl animate-pulse pointer-events-none"
                            style={{
                                background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.4), rgba(139, 92, 246, 0.4))',
                                filter: 'blur(30px)',
                            }}
                        />
                        <h3 className="text-white text-2xl font-bold mb-6 flex items-center gap-3 relative">
                            <span className="text-4xl animate-bounce">🌡️</span>
                            Climat Global
                            <span className="ml-2 text-sm bg-blue-500/30 px-3 py-1 rounded-full animate-pulse">FOCUS</span>
                        </h3>
                        <div className="grid grid-cols-2 gap-4 mb-4 relative">
                            <div className="bg-orange-500/20 p-4 rounded-xl text-center scale-105 transition-all">
                                <div className="text-3xl font-bold text-orange-400">+1.8°C</div>
                                <div className="text-sm text-orange-300 mt-1">Temp. moy.</div>
                            </div>
                            <div className="bg-blue-500/20 p-4 rounded-xl text-center scale-105 transition-all">
                                <div className="text-3xl font-bold text-blue-400">+23cm</div>
                                <div className="text-sm text-blue-300 mt-1">Océans</div>
                            </div>
                            <div className="bg-red-500/20 p-4 rounded-xl text-center scale-105 transition-all">
                                <div className="text-3xl font-bold text-red-400">-15%</div>
                                <div className="text-sm text-red-300 mt-1">Biodiversité</div>
                            </div>
                            <div className="bg-purple-500/20 p-4 rounded-xl text-center scale-105 transition-all">
                                <div className="text-3xl font-bold text-purple-400">421ppm</div>
                                <div className="text-sm text-purple-300 mt-1">CO2</div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className={isSlide ? "w-full h-full custom-scrollbar overflow-y-auto" : "popup-content custom-scrollbar"}>
                {articles.map((newspaper) => (
                    <div key={newspaper.year} className="min-h-screen text-slate-200 leading-relaxed"
                        style={{
                            background: 'linear-gradient(135deg, #0c1017 0%, #1a1f2e 50%, #0f1419 100%)',
                            fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif"
                        }}>

                        {/* Header */}
                        <header
                            className="sticky top-0 z-50 py-4 border-b border-blue-500/20"
                            style={{
                                background: `rgba(15, 20, 25, ${headerOpacity})`,
                                backdropFilter: 'blur(20px)'
                            }}
                        >
                            <div className="max-w-7xl mx-auto px-8 flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl flex items-center justify-center font-bold text-white text-xl">
                                        SN
                                    </div>
                                    <div>
                                        <div className="text-3xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                            SYNAPSE NEWS
                                        </div>
                                        <div className="text-sm text-slate-500 -mt-1">Ce que l’algorithme autorise à diffuser</div>
                                    </div>
                                </div>
                                <div className="flex items-center gap-4">
                                    <div className="text-3xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                        {newspaper.year}
                                    </div>
                                    {!isSlide && (
                                        <>
                                            <Boutton
                                                text="ARTICLES    "
                                                onClick={backChoice}
                                                text_after="HISTORIQUE"
                                                delay={0}
                                                variant="yellow"
                                            />
                                            <Boutton
                                                text="x FERMER"
                                                onClick={onClose}
                                                text_after="← Retour"
                                                delay={0}
                                                variant="red"
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </header>
                        {guerres?.length > 0 && (
                            <div className="absolute top-0 left-0 w-full bg-gray-900 text-white overflow-hidden z-50 h-6 flex items-center" style={{ overflow: "hidden" }}>
                                <div className="animate-marquee whitespace-nowrap">
                                    {guerres.map((guerre, index) => (
                                        <span key={index} className="mx-8 inline-block">
                                            <strong className="text-green-600">          ⚔️</strong>
                                            <strong className="text-green-400">✅{guerre.Vainqueur}✅</strong> a vaincu{" "}
                                            <strong className="text-red-400">❌{guerre.Perdant}❌</strong> et a conquis{" "}
                                            <strong className="text-blue-400">{guerre.Territoire}</strong> territoire(s)
                                            <strong className="text-blue-400">☠️ {guerre.perte_population}</strong> mort(s)
                                            <strong className="text-blue-400">et {guerre.resources}</strong> resources.
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Main layout container: Articles on left, Sidebar on right */}
                        <div className={`max-w-full mx-auto p-4 lg:p-8 flex items-stretch justify-center min-h-screen`}>

                            {/* Main Content (Articles) */}
                            <main className="flex-grow flex flex-col gap-10 max-w-5xl mr-0 md:mr-8 h-full">
                                {/* Hero Section */}
                                <section
                                    className="relative"
                                    style={{
                                        ...sectionStyles,
                                        background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1))',
                                        border: '2px solid rgba(59, 130, 246, 0.2)'
                                    }}
                                >
                                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-green-500"></div>
                                    <div
                                        className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-blue-500 px-3 py-1 rounded-full text-sm font-semibold text-white mb-4 cursor-pointer"
                                        onClick={handleAIBadgeClick}
                                    >
                                        <div className="w-4 h-4 bg-white/30 rounded-full flex items-center justify-center text-xs">🤖</div>
                                        Rédigé par IA Nexus
                                    </div>
                                    <h2 className="text-2xl font-bold mb-6 text-slate-100 flex items-center gap-3">
                                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center text-white">🔥</div>
                                        À la une
                                    </h2>
                                    <h3 className="text-3xl font-semibold mb-4 leading-tight bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
                                        {highlightCountry(newspaper.headlineTitle)}
                                    </h3>
                                    {newspaper.imageUrl && (
                                        <div className="mb-6 rounded-xl overflow-hidden border border-blue-500/20 shadow-2xl">
                                            <img
                                                src={newspaper.imageUrl}
                                                alt="Article Illustration"
                                                className="w-full h-auto object-cover max-h-[400px]"
                                            />
                                        </div>
                                    )}
                                    <div className="text-slate-300 mb-4">
                                        {highlightCountry(newspaper.headline)}
                                    </div>
                                    <div className="flex items-center gap-4 text-sm text-slate-500 mt-4">
                                        <span>🕒 Il y a 2 heures</span>
                                        <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500">📖 3 min de lecture</span>
                                        <span>🌍 International</span>
                                    </div>
                                </section>

                                {/* Banner Ad */}
                                <div
                                    className="relative bg-gradient-to-r from-slate-800 to-slate-700 border border-blue-500/20 rounded-xl p-8 text-center text-slate-400 overflow-hidden"
                                    style={{ background: 'linear-gradient(45deg, #1e293b, #334155)' }}
                                >
                                    <div
                                        className="absolute top-0 left-0 w-full h-full opacity-30"
                                        style={{ background: 'linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.1), transparent)', animation: 'shimmer 3s infinite', transform: 'translateX(-100%)' }}
                                    ></div>
                                    {isSlide ? (
                                        <img
                                            src={title === "MARATHON NEWS" ? pub2 : pub}
                                            alt="Publicité premium"
                                            className="w-full rounded-lg shadow-md border border-blue-500/10"
                                        />
                                    ) : (
                                        <>
                                            <strong>PUBLICITÉ PREMIUM</strong><br />
                                            Découvrez les dernières innovations technologiques<br />
                                            <em>Espace publicitaire 728x90</em>
                                        </>
                                    )}
                                </div>

                                {/* News Brief */}
                                <section style={sectionStyles} className="hover:-translate-y-1 hover:border-blue-500/30 hover:shadow-2xl">
                                    <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-blue-500 px-3 py-1 rounded-full text-sm font-semibold text-white mb-4 cursor-pointer" onClick={handleAIBadgeClick}>
                                        <div className="w-4 h-4 bg-white/30 rounded-full flex items-center justify-center text-xs">🤖</div>
                                        Synthèse IA Sociale
                                    </div>
                                    <h2 className="text-2xl font-bold mb-6 text-slate-100 flex items-center gap-3">
                                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">🚨</div>
                                        Faits divers
                                    </h2>
                                    <h3 className="text-xl font-semibold text-slate-200 mb-4 leading-tight">
                                        {highlightCountry(newspaper.sectionDiversTitle)}
                                    </h3>
                                    {title === "MARATHON NEWS" && (
                                        <img
                                            src={factorio}
                                            alt="factorio"
                                            className="w-full rounded-lg shadow-md border border-blue-500/10"
                                        />
                                    )}
                                    < div className="text-slate-300 mb-4">
                                        {highlightCountry(newspaper.sectionDivers)}
                                    </div>
                                    <div className="flex items-center gap-4 text-sm text-slate-500 mt-4">
                                        <span>🕒 Il y a 6 heures</span>
                                        <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500">📖 2 min de lecture</span>
                                        <span>🚑 Société</span>
                                    </div>
                                </section>

                                {/* World News */}
                                <section style={sectionStyles} className="hover:-translate-y-1 hover:border-blue-500/30 hover:shadow-2xl">
                                    <div className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-blue-500 px-3 py-1 rounded-full text-sm font-semibold text-white mb-4 cursor-pointer" onClick={handleAIBadgeClick}>
                                        <div className="w-4 h-4 bg-white/30 rounded-full flex items-center justify-center text-xs">🤖</div>
                                        Fact-check IA Global
                                    </div>
                                    <h2 className="text-2xl font-bold mb-6 text-slate-100 flex items-center gap-3">
                                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center">🌍</div>
                                        En bref dans le monde
                                    </h2>
                                    <h3 className="text-xl font-semibold text-slate-200 mb-4 leading-tight">
                                        {highlightCountry(newspaper.sectionBrefTitle)}
                                    </h3>
                                    <div className="text-slate-300 mb-4">
                                        {highlightCountry(newspaper.sectionBref)}
                                    </div>
                                    <div className="flex items-center gap-4 text-sm text-slate-500 mt-4">
                                        <span>🕒 Il y a 8 heures</span>
                                        <span className="bg-blue-500/10 px-2 py-1 rounded text-blue-500">📖 2 min de lecture</span>
                                        <span>🌐 International</span>
                                    </div>
                                </section>
                            </main>

                            {/* Right Sidebar - Always Visible */}
                            <aside
                                className="w-80 flex-shrink-0 bg-slate-900/95 backdrop-blur-xl border-l border-blue-500/20 sticky top-0 h-full overflow-y-auto hidden md:block"
                            >

                                {/* Sidebar Content (scrollable) */}
                                <div className="flex flex-col gap-6 p-6">
                                    {/* Weather Widget */}
                                    <div
                                        style={{ background: 'rgba(30, 41, 59, 0.6)', backdropFilter: 'blur(15px)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '16px', padding: '1.5rem' }}
                                        className="text-center"
                                    >
                                        <h3 className="text-lg font-bold mb-3 text-slate-100 flex items-center justify-center gap-2">
                                            Météo - Couëron
                                        </h3>
                                        <div className="text-4xl font-extrabold mb-2 bg-gradient-to-r from-yellow-500 to-red-500 bg-clip-text text-transparent">
                                            {currentTemp ?? '--'}°
                                        </div>
                                        <p className="text-slate-400 mb-3">{description}</p>
                                        <div className="flex justify-between text-slate-500 text-sm bg-slate-800/30 rounded-lg p-2">
                                            <span>Min: {min ?? '--'}°</span> <span>Max: {max ?? '--'}°</span>
                                        </div>
                                        <div className="mt-3 text-xs text-slate-500">🔄 Mise à jour: {lastUpdate ? lastUpdate.toLocaleTimeString('fr-FR') : '--'}</div>
                                    </div>

                                    {/* Climate Stats */}
                                    <div
                                        className={`transition-all duration-500 cursor-pointer hover:border-blue-400/50 ${climateFocusActive ? 'opacity-30' : ''}`}
                                        style={{
                                            background: 'rgba(30, 41, 59, 0.6)',
                                            backdropFilter: 'blur(15px)',
                                            border: '1px solid rgba(59, 130, 246, 0.2)',
                                            borderRadius: '16px',
                                            padding: '1.5rem',
                                        }}
                                        onClick={() => isSlide && setClimateFocusActive(true)}
                                    >
                                        <h3 className="text-lg font-bold mb-4 text-slate-100 flex items-center gap-2">
                                            <span className="text-xl">🌡️</span> Climat Global
                                        </h3>
                                        <div className="grid grid-cols-2 gap-3 mb-4">
                                            <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                                                <div className="text-lg font-bold text-orange-400">+1.8°C</div>
                                                <div className="text-xs text-slate-500">Temp. moy.</div>
                                            </div>
                                            <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                                                <div className="text-lg font-bold text-blue-400">+23cm</div>
                                                <div className="text-xs text-slate-500">Océans</div>
                                            </div>
                                            <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                                                <div className="text-lg font-bold text-red-400">-15%</div>
                                                <div className="text-xs text-slate-500">Biodiversité</div>
                                            </div>
                                            <div className="bg-slate-800/40 p-3 rounded-lg text-center">
                                                <div className="text-lg font-bold text-purple-400">421ppm</div>
                                                <div className="text-xs text-slate-500">CO2</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Stats Live - Flux NEXUS */}
                                    <div style={{ background: 'rgba(30, 41, 59, 0.6)', backdropFilter: 'blur(15px)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '16px', padding: '1.5rem' }}>
                                        <h3 className="text-lg font-bold mb-4 text-slate-100 flex items-center gap-2">
                                            <span className="text-xl animate-pulse">⚡</span> Stats Live
                                        </h3>
                                        <div className="space-y-3">
                                            {newspaper.sectionEliminations?.split('\n').filter(line => line.trim()).map((line, idx) => {
                                                const isElimination = line.includes('💀');
                                                const isSimulation = line.includes('⚠️') || line.includes('📉') || line.includes('🖥️') || line.includes('🪵') || line.includes('🛡️') || line.includes('💸');

                                                let bgColor = 'bg-slate-800/40';
                                                let borderColor = 'border-slate-700/50';
                                                let textColor = 'text-slate-300';

                                                if (isElimination) {
                                                    bgColor = 'bg-red-500/10';
                                                    borderColor = 'border-red-500/30';
                                                    textColor = 'text-red-200';
                                                } else if (isSimulation) {
                                                    bgColor = 'bg-orange-500/10';
                                                    borderColor = 'border-orange-500/30';
                                                    textColor = 'text-orange-200';
                                                }

                                                return (
                                                    <div
                                                        key={idx}
                                                        className={`p-3 rounded-lg border text-sm leading-tight transition-all hover:scale-[1.02] cursor-default ${bgColor} ${borderColor} ${textColor}`}
                                                    >
                                                        {highlightCountry(line)}
                                                    </div>
                                                );
                                            })}
                                            {!newspaper.sectionEliminations?.trim() && (
                                                <div className="text-center py-4 text-slate-500 italic text-sm">
                                                    Aucun événement majeur à signaler.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Advertisement */}
                                    <div className="relative bg-gradient-to-br from-purple-900/50 to-blue-900/50 border border-purple-500/30 rounded-xl p-4 text-center overflow-hidden">
                                        <div className="absolute top-0 left-0 w-full h-full opacity-20" style={{ background: 'linear-gradient(90deg, transparent, rgba(139, 92, 246, 0.3), transparent)', animation: 'shimmer 4s infinite', transform: 'translateX(-100%)' }}></div>
                                        <div className="relative z-10">
                                            <div className="text-purple-300 font-semibold mb-2">✨ SPONSOR</div>
                                            <div className="text-sm text-slate-300 mb-2"><strong>VIF</strong></div>
                                            <div className="text-xs text-slate-400 mb-3">PME, ETI, déployez votre Potentiel Industriel</div>
                                            <a
                                                href="https://vif.fr"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bg-purple-500/20 hover:bg-purple-500/30 border border-purple-400/30 text-purple-300 px-3 py-2 rounded-md inline-block"
                                            >
                                                Visiter vif.fr
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>

                        {/* Footer */}
                        < footer
                            className="border-t border-blue-500/20 mt-16 py-12 px-8"
                            style={{ background: 'rgba(15, 20, 25, 0.8)' }}
                        >
                            <div className="max-w-7xl mx-auto text-center">
                                <div className="text-2xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent mb-4">
                                    NEXUS
                                </div>
                                <p className="text-slate-500 mb-8">
                                    L'information augmentée par l'intelligence artificielle. Transparence, innovation et fiabilité.
                                </p>
                                <div className="flex justify-center gap-8 mb-8">
                                    <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">À propos</a>
                                    <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Notre IA</a>
                                    <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Éthique</a>
                                    <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Contact</a>
                                    <a href="#" className="text-slate-400 hover:text-blue-500 transition-colors">Mentions légales</a>
                                </div>
                                <p className="text-slate-500 text-sm">
                                    © 2026 NEXUS News. Tous droits réservés. Propulsé par l'IA éthique.
                                </p>
                            </div>
                        </footer>

                        <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
                    </div>
                ))}
            </div >
        </div >
    );
});

export default SynapseNews;